import React, { useEffect, useRef, useCallback, useMemo, useState } from 'react';

import { LoadPanel } from 'devextreme-react/load-panel';
import AntErrorPage from './AntErrorPage';
import AntCondition from '../utils/AntCondition';
import AntLocalization from '../utils/AntLocalization';

import { AntGlobal, AntSession } from '../utils/AntContext';

export default function (props) {
    const appGlobal = AntGlobal();
    // const session = AntSession();

    var isVisible = props.visible !== undefined ? props.visible : true;
    var isRender = AntCondition.isRender({}, props);
    var isAnte = appGlobal && appGlobal.appInfo && appGlobal.appInfo.isAnte;

    var bgImage = props.backgroundImage
        ? props.backgroundImage
        : isAnte && appGlobal && appGlobal.appAssets && appGlobal.appAssets.images.searchPageBackground
        ? appGlobal.appAssets.images.searchPageBackground
        : props.backgroundImage;

    const [shouldRender, setShouldRender] = useState(1);
    const forceRender = useCallback(() => {
        setShouldRender((v) => v + 1);
    }, []);


    return (
        <React.Fragment>
            {/* <div className={'content-block ant-page-content-block'} style={{ visibility: isVisible ? 'visible' : 'hidden' }}> */}

            {shouldRender && (
                <div
                    className={'content-block ant-page ' + (props.className ? props.className : '')}
                    style={{ display: isVisible ? 'block' : 'none', height: 'fit-content' }}
                >
                    {!isRender && (
                        <AntErrorPage
                            text={AntLocalization.translateText({ vi: 'Không có quyền truy cập !', en: 'Access Denied', fr: 'Accès refusé', es: 'Acceso denegado', id: 'Akses ditolak', ja: 'アクセス拒否', zh: '访问被拒绝', ko: '접근 거부', hi: 'पहुँच अस्वीकृत', ar: 'تم رفض الوصول' })}
                        />
                    )}
                    {isRender && (
                        <div
                            style={{
                                marginLeft: props.marginLeft,
                                marginRight: props.marginRight,
                                marginTop: props.marginTop,
                                marginBottom: props.marginBottom,
                                height: 'fit-content'
                            }}
                        >
                            {props.children}
                        </div>
                    )}
                    {isRender && !props.hideBackgroundImage && bgImage && (
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 0, height: 'fit-content' }}>
                            <img
                                style={{
                                    width: props.backgroundImageWidth ? props.backgroundImageWidth : 220,
                                    opacity: props.backgroundImageOpacity ? props.backgroundImageOpacity : 0.4,
                                    marginTop: 0
                                }}
                                src={bgImage}
                            ></img>
                        </div>
                    )}
                </div>
            )}
            {/* 
                {!props.visible && (
                    <div>
                        <LoadPanel
                            visible={!props.visible}
                            showPane={false}
                            shading={true}
                            shadingColor={'rgba(119, 119, 128, 0.16)'}
                            // indicatorSrc={'https://image.flaticon.com/icons/svg/3305/3305803.svg'}
                        />
                    </div>
                )} */}
        </React.Fragment>
    );
}
